import configStore from '@store/ConfigStore';

export interface DadataSuggestion {
  value: string | null; // "г Москва, ул Окружная, д 10А",
  unrestricted_value: string | null; // "125476, г Москва, р-н Южное Тушино, ул Окружная, д 10А",
  data: {
    postal_code: string | null; // "125476",
    country: string | null; // "Россия",
    country_iso_code: string | null; // "RU",
    federal_district: string | null; // "Центральный",
    region_fias_id: string | null; // "0c5b2444-70a0-4932-980c-b4dc0d3f02b5",
    region_kladr_id: string | null; // "7700000000000",
    region_iso_code: string | null; // "RU-MOW",
    region_with_type: string | null; // "г Москва",
    region_type: string | null; // "г",
    region_type_full: string | null; // "город",
    region: string | null; // string // "Москва",
    area_fias_id: string | null; // null
    area_kladr_id: string | null; // null
    area_with_type: string | null; // null
    area_type: string | null; // null
    area_type_full: string | null; // null
    area: string | null; // null
    city_fias_id: string | null; // '0c5b2444-70a0-4932-980c-b4dc0d3f02b5'
    city_kladr_id: string | null; // '7700000000000'
    city_with_type: string | null; // 'г Москва'
    city_type: string | null; // 'г'
    city_type_full: string | null; // 'город'
    city: string | null; // 'Москва'
    city_area: string | null; // 'Северо-западный'
    city_district_fias_id: string | null; // null
    city_district_kladr_id: string | null; // null
    city_district_with_type: string | null; // null
    city_district_type: string | null; // null
    city_district_type_full: string | null; // null
    city_district: string | null; // null
    settlement_fias_id: string | null; // null
    settlement_kladr_id: string | null; // null
    settlement_with_type: string | null; // null
    settlement_type: string | null; // null
    settlement_type_full: string | null; // null
    settlement: string | null; // null
    street_fias_id: string | null; // '658a7b9b-a45a-48c0-bf39-837cc4871df3'
    street_kladr_id: string | null; // '77000000000211200'
    street_with_type: string | null; // 'ул Окружная'
    street_type: string | null; // 'ул'
    street_type_full: string | null; // 'улица'
    street: string | null; // 'Окружная'
    stead_fias_id: string | null; // null
    stead_cadnum: string | null; // null
    stead_type: string | null; // null
    stead_type_full: string | null; // null
    stead: string | null; // null
    house_fias_id: string | null; // '4de44a84-0e80-49b8-b12e-c0e20d194aeb'
    house_kladr_id: string | null; // '7700000000021120014'
    house_cadnum: string | null; // null
    house_flat_count: string | null; // null
    house_type: string | null; // 'д'
    house_type_full: string | null; // 'дом'
    house: string | null; // '10А'
    block_type: string | null; // null
    block_type_full: string | null; // null
    block: string | null; // null
    entrance: string | null; // null
    floor: string | null; // null
    flat_fias_id: string | null; // null
    flat_cadnum: string | null; // null
    flat_type: string | null; // null
    flat_type_full: string | null; // null
    flat: string | null; // null
    flat_area: string | null; // null
    square_meter_price: string | null; // null
    flat_price: string | null; // null
    room_fias_id: string | null; // null
    room_cadnum: string | null; // null
    room_type: string | null; // null
    room_type_full: string | null; // null
    room: string | null; // null
    postal_box: string | null; // null
    fias_id: string | null; // '4de44a84-0e80-49b8-b12e-c0e20d194aeb'
    fias_code: string | null; // null
    fias_level: string | null; // '8'
    fias_actuality_state: string | null; // '0'
    kladr_id: string | null; // '7700000000021120014'
    geoname_id: string | null; // '524901'
    capital_marker: string | null; // '0'
    okato: string | null; // '45283593000'
    oktmo: string | null; // '45373000'
    tax_office: string | null; // '7733'
    tax_office_legal: string | null; // '7733'
    timezone: string | null; // null
    geo_lat: string | null; // '55.8441953'
    geo_lon: string | null; // '37.4003554'
    beltway_hit: string | null; // 'IN_MKAD'
    beltway_distance: string | null; // null
    metro: string | null; // null
    divisions: string | null; // null
    qc_geo: string | null; // '0'
    qc_complete: string | null; // null
    qc_house: string | null; // null
    history_values: string | null; // null
    unparsed_parts: string | null; // null
    source: string | null; // null
    qc: string | null; // null
  };
}

interface Bound {
  value: string;
}

export interface GetMapSuggestionsSuggestArgsLocation {
  region_fias_id?: string;
  city_fias_id?: string;
  settlement_fias_id?: string;
  street_fias_id?: string;
  kladr_id?: string;
}

export interface GetMapSuggestionsSuggestArgs {
  query: string; // required

  count?: number | null; // default: 10

  from_bound?: Bound;

  to_bound?: Bound;

  restrict_value?: boolean | null; // default: false

  locations?: GetMapSuggestionsSuggestArgsLocation[];
}

const getToken = (): string | null | undefined =>
  configStore.getValue('dadata_api_key');

class DadataAPI {
  getMapSuggestionsGeolocate = async (
    lat: string,
    lon: string
  ): Promise<{ suggestions: DadataSuggestion[] }> =>
    await fetch(
      'https://suggestions.dadata.ru/suggestions/api/4_1/rs/geolocate/address',
      {
        method: 'POST',
        headers: {
          Authorization: `Token ${getToken()}`,
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ lat, lon })
      }
    ).then(
      async response =>
        (await response.json()) as { suggestions: DadataSuggestion[] }
    );

  getMapSuggestionsSuggest = async (
    payload: GetMapSuggestionsSuggestArgs,
    signal?: AbortSignal
  ): Promise<{ suggestions: DadataSuggestion[] }> =>
    await fetch(
      'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
      {
        method: 'POST',
        headers: {
          Authorization: `Token ${getToken()}`,
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload),
        signal
      }
    ).then(
      async response =>
        (await response.json()) as { suggestions: DadataSuggestion[] }
    );
}

export default new DadataAPI();
